import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc, doc, getDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDPsmNMBJRDHQGzYYgMIJQme0MEa4fRjJw",
  authDomain: "cloud-upskill-d08b5.firebaseapp.com",
  projectId: "cloud-upskill-d08b5",
  storageBucket: "cloud-upskill-d08b5.firebasestorage.app",
  messagingSenderId: "931876164155",
  appId: "1:931876164155:web:d5e1bfc1951426f4f9021e",
  measurementId: "G-MNBCF7PN1E"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, auth, storage, collection, addDoc };
